import site from "config/meta";
import { publisher } from "./commonSchema";

export const collectionPage = {
  "@context": "https://schema.org/",
  "@type": "WebPage",
  "@type": "CollectionPage",
  "@id": site.siteMetadata.siteUrl + "/blogs",
  url: site.siteMetadata.siteUrl + "/blogs",
  name: "Gaming Blog - EpicPlay.in",
  datePublished: new Date("10-22-2022".replace(/-/g, "/")).toISOString(),
  dateModified: new Date().toISOString(),
  description:
    "EpicPlay.in is a source for the latest in gaming news, reviews, and tips. Whether you're a casual or hardcore gamer, we have something for you. Check it out!",
  inLanguage: "en",
  isPartOf: {
    "@type": "WebSite",
    "@id": site.siteMetadata.siteUrl + "/#website",
    url: site.siteMetadata.siteUrl,
    name: "EpicPlay",
    description:
      "EpicPlay.in is a source for the latest in gaming news, reviews, and tips. Whether you're a casual or hardcore gamer, we have something for you. Check it out!",
    inLanguage: "en",
    publisher: {
      "@type": "Organization",
      "@id": site.siteMetadata.siteUrl + "/#organization",
      name: "EpicPlay",
      url: site.siteMetadata.siteUrl,
      sameAs: [
        "https://www.facebook.com/Epic-Play-100534342864317",
        "https://www.instagram.com/epicplay.in/",
        "https://youtube.com/@epicplay_in",
        "https://twitter.com/epicplay_in",
        
      ],
      logo: {
        "@type": "ImageObject",
        "@id": site.siteMetadata.siteUrl + "/#/schema/logo/image/",
        inLanguage: "en",
        url: site.siteMetadata.image,
        contentUrl: site.siteMetadata.image,
        caption: "EpicPlay",
      },
      image: {
        "@type": "ImageObject",
        "@id": site.siteMetadata.siteUrl + "/#/schema/logo/image/",
        inLanguage: "en",
        url: site.siteMetadata.image,
        contentUrl: site.siteMetadata.image,
        caption: "EpicPlay",
      },
      potentialAction: {
        "@type": "SearchAction",
        target: {
          "@type": "EntryPoint",
          urlTemplate: site.siteMetadata.siteUrl + "/blogs?=search_term_string",
        },
        "query-input": {
          "@type": "PropertyValueSpecification",
          valueName: "search_term_string",
          valueRequired: false,
        },
      },
    }
  },
  breadcrumb: {
    "@type": "BreadcrumbList",
    "@id": site.siteMetadata.siteUrl + "/blogs/#breadcrumb",
    itemListElement: {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: {
        "@type": "Thing",
        "@id": site.siteMetadata.siteUrl,
      },
    },
    itemListElement: {
      "@type": "ListItem",
      position: 2,
      name: "Blog",
    },
  },
};

export const generateArticleSchema = (blog, path) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline:
    blog?.schema?.title || blog?.metaTitle || blog?.customTitle || blog?.title,
  description: blog?.metaDescription||blog?.description,
  ...(blog?.dateModified ? { dateModified: blog.dateModified } : {}),
  datePublished: blog?.date,
  image: {
    '@type': 'ImageObject',
    creator: {
      '@type': 'Organization',
      name: 'EpicPlay'
    },
    url: site.siteMetadata.siteUrl + blog?.image,
    width: 700,
    height: 300
  },
  author: {
    '@type': 'Person',
    name: blog?.author
  },
  ...(blog?.schema && {
    teaches: {
      '@type': 'DefinedTerm',
      name: blog?.schema?.name,
      description: blog?.schema?.description
    }
  }),
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': site.siteMetadata.siteUrl + path
  },
  ...publisher
});

export const blogBreadCrumbSchema = (blog, path) => ({
  '@context': 'https://schema.org/',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: site.siteMetadata.siteUrl
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Blogs',
      item: site.siteMetadata.siteUrl + '/blogs'
    },
    {
      '@type': 'ListItem',
      position: 3,
      name: blog?.metaTitle || blog?.customTitle || blog?.title,
      item: site.siteMetadata.siteUrl + path
    }
  ]
});
